import Button from "../forms/Buttons/BlueButton";
import TextInput from "../forms/TextInput";
import PasswordInput from "../forms/PasswordInput";
import Upload from "../forms/Buttons/UploadButton";
import LabelInput from "../forms/Label";
import CheckboxInput from "../forms/CheckboxInput";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import isValidLogoFormat, { validPassword } from "../../utils/validation";
import {
  invalidLogoFormatMessage,
  invalidPasswordMessage,
  invalidSizeFile,
  maxUploadFileSize,
  passwordsNotMatchMessage,
} from "../../errors/errors";
import Error from "../Alert/Error";
import { adminActions } from "../../actions/admin.actions";
import { useEffect } from "react";
import SubmitButton from "../forms/Buttons/SubmitButton";

export default function Details({ user, userId }) {
  const [updatePassword, setUpdatePassword] = useState(false);
  const [userImage, setUserImage] = useState(null);
  const [file, setFile] = useState(null);
  const [imageRemoved, setImageRemoved] = useState(false);
  const [userFileName, setUserFileName] = useState(null);
  const [userFileSize, setUserFileSize] = useState(null);
  const [errorCount, setErrorCount] = useState(0);
  const [passwordTyped, setPasswordTyped] = useState("");
  const [companyExpertises, setCompanyExpertises] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const userUpdated = useSelector((state) => state.admin.updated_user);
  const previousUserRef = useRef(null);

  const {
    handleSubmit,
    getValues,
    register,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const handleCloseModal = () => {
    setUserImage(null);
    setUserFileName(null);
  };

  useEffect(() => {
    if (previousUserRef.current !== null) {
      // Comparer le user actuel avec le user précédent
      if (user?.email !== previousUserRef?.current?.email) {
        setValue("LastName", user?.lastName || "");
        setValue("FirstName", user?.firstName || "");
        setValue("Email", user?.email || "");
        setValue("CompanyName", user?.companyName || "");
        setValue("CompanyAddress", user?.companyAddress || "");
        setValue("CompanyExpertise", user?.companyExpertise || "");
        setValue("CompanyWebsite", user?.companyWebsite || "");
        setValue("PhoneNumber", user?.phoneNumber || "");
        setValue("UserName", user?.email || "");
      }
      previousUserRef.current = user;
    } else {
      // Cas du premier rendu, initialiser la référence du user précédent
      previousUserRef.current = user;
    }
  }, [user, setValue]);

  // useEffect(() => {
  //   console.log(`user: ${JSON.stringify(user)}`);
  //   setValue("LastName", user?.lastName || "");
  //   setValue("FirstName", user?.firstName || "");
  //   setValue("Email", user?.email || "");
  //   setValue("CompanyName", user?.companyName || "");
  //   setValue("CompanyAddress", user?.companyAddress || "");
  //   setValue("CompanyExpertise", user?.companyExpertise || "");
  //   setValue("PhoneNumber", user?.phoneNumber || "");
  //   setValue("UserName", user?.email || "");
  //   reset();
  // }, [user, setValue, reset]);

  // useEffect(() => {
  //   if (user) {
  //     reset({
  //       LastName: user?.lastName || "",
  //       FirstName: user?.firstName || "",
  //       Email: user?.email || "",
  //       CompanyName: user?.companyName || "",
  //       CompanyAddress: user?.companyAddress || "",
  //       CompanyExpertise: user?.companyExpertise || "",
  //       PhoneNumber: user?.phoneNumber || "",
  //       UserName: user?.email || "",
  //     });
  //   } else {
  //     reset({
  //       LastName: "",
  //       FirstName: "",
  //       Email: "",
  //       CompanyName: "",
  //       CompanyAddress: "",
  //       CompanyExpertise: "",
  //       PhoneNumber: "",
  //       UserName: "",
  //     });
  //   }
  // // }, [user, reset]);
  // useEffect(() => {
  //   if (user) {
  //     reset({
  //       LastName: user.lastName || "",
  //       FirstName: user.firstName || "",
  //       Email: user.email || "",
  //       CompanyName: user.companyName || "",
  //       CompanyAddress: user.companyAddress || "",
  //       CompanyExpertise: user.companyExpertise || "",
  //       PhoneNumber: user.phoneNumber || "",
  //       UserName: user.email || "",
  //     });
  //   }
  // }, [user, reset]);

  const updateInputValue = (fieldName, value) => {
    if (fieldName === "Password") setPasswordTyped(value);
    setValue(fieldName, value);
  };

  const onSubmitForm = () => {
    setIsLoading(true);
    let userData = new FormData();
    console.log(`values: ${JSON.stringify(getValues())}`);
    const companyExpertises = getValues().CompanyExpertise || [];
    companyExpertises?.forEach((value, index) => {
      userData.append(`CompanyExpertise[${index}]`, value);
    });
    const role = companyExpertises && handleSettingRole(companyExpertises);
    userData.append("LastName", getValues().LastName);
    userData.append("FirstName", getValues().FirstName);
    userData.append("ClienType", 2);
    userData.append("Email", getValues().Email);
    userData.append("PhoneNumber", getValues().PhoneNumber);
    getValues().Password && userData.append("Password", getValues().Password);
    getValues().ConfirmPassword &&
      userData.append("ConfirmPassword", getValues().ConfirmPassword);
    userData.append("CompanyName", getValues().CompanyName);
    userData.append("CompanyWebsite", getValues().CompanyWebsite);
    userData.append("CompanyAddress", getValues().CompanyAddress);
    userData.append("UserRole", role);
    file && userData.append("File", file);
    imageRemoved &&
      userData.append("File", null) &&
      userData.append("CompanyLogo", null);
    console.log(`data: ${JSON.stringify(JSON.stringify(userData))}`);
    dispatch(adminActions.updateUser(userId, userData));
    reset();
  };

  const onChooseFile = (e) => {
    console.log("choose file");
    const file = e.target.files[0];
    setUserImage(URL.createObjectURL(file));
    setFile(file);
    setUserFileName(file.name);
    setUserFileSize(file.size);
  };

  const handleSettingRole = (companyExpertises) => {
    if (companyExpertises.includes("3")) {
      return "VAP";
    } else if (companyExpertises.includes("2")) {
      return "CMAP";
    } else if (companyExpertises.includes("1")) {
      return "GHG";
    } else if (companyExpertises.includes("4")) {
      return "Other";
    }
  };

  const handleChangeCompanyExpertise = (e) => {
    const value = parseInt(e.target.value);
    console.log(`type of value: ${typeof value}`);
    console.log(`default ce: ${companyExpertises.map((val) => typeof val)}`);
    if (companyExpertises?.includes(value)) {
      console.log(
        `yes its include: ${companyExpertises?.filter(
          (element) => element != value
        )}`
      );
      setCompanyExpertises(
        companyExpertises?.filter((element) => element != value)
      );
    } else {
      console.log(`not include ${[...companyExpertises, value]}`);
      setCompanyExpertises([...companyExpertises, value]);
    }
    console.log(`after ce: ${companyExpertises}`);
  };

  useEffect(() => {
    setCompanyExpertises(user?.companyExpertise);
  }, [user?.companyExpertise]);

  useEffect(() => {
    if (userUpdated && userUpdated?.data.id === userId) {
      setIsLoading(false);
      document.getElementById("closeButton").click();
    }
  }, [userUpdated, userId]);

  return (
    <div>
      <div
        id="hs-user-details"
        className="hs-overlay hidden w-full h-full fixed top-4 left-1/4 bottom-1/4 z-[60] overflow-x-hidden overflow-y-auto"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all w-6/12">
          <div className="relative flex flex-col bg-white border shadow-sm rounded-xl overflow-auto dark:bg-gray-800 dark:border-gray-700">
            <div className="absolute top-2 right-2">
              <button
                id="closeButton"
                type="button"
                className="inline-flex flex-shrink-0 rounded-full border-light-grey justify-center items-center h-8 w-8 rounded-md text-gray-500 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white transition-all text-sm dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800"
                data-hs-overlay="#hs-user-details"
                onClick={handleCloseModal}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit(onSubmitForm)}>
              <div className="p-4 sm:p-10 overflow-y-auto">
                <h3 className="text-xl font-bold text-gray-800 dark:text-gray-200 flex">
                  {user?.firstName} {user?.lastName}
                  <span className="text-gray-400 hover:text-gray-500 hover:cursor-pointer ml-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                      <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
                    </svg>
                  </span>
                </h3>
                <p className="text-gray-400 font-light">
                  Change information about this profile
                </p>
                <div className="profile mt-4">
                  <div className="img flex">
                    {userImage ? (
                      <img
                        src={userImage}
                        alt="upload logo"
                        className="w-[120px] h-[120px] object-cover rounded-full"
                      />
                    ) : (
                      <img
                        src={`data:image/jpeg;base64,${user?.companyLogo}`}
                        alt="company logo"
                        className="w-[120px] h-[120px] object-cover rounded-full"
                      />
                    )}

                    <div className="ml-4">
                      <Upload
                        label="Change picture"
                        onChange={onChooseFile}
                        id="upload-user-image"
                      >
                        <svg
                          className="w-5 h-5 mr-2 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                          />
                        </svg>
                      </Upload>
                      <p className="mt-2 text-sm text-gray">
                        {userFileName
                          ? userFileName
                          : "only .jpg or .png files are accepted"}
                      </p>
                      {userFileName && !isValidLogoFormat(userFileName) && (
                        <Error
                          key={errorCount}
                          text={invalidLogoFormatMessage}
                        />
                      )}
                      {userFileSize && userFileSize > maxUploadFileSize && (
                        <Error key={errorCount} text={invalidSizeFile} />
                      )}

                      {/*<Button className="mt-2">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="mr-2 w-5 h-5">
		<path fillRule="evenodd" d="M11.47 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06l-3.22-3.22V16.5a.75.75 0 01-1.5 0V4.81L8.03 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zM3 15.75a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z" clipRule="evenodd" />
		</svg>
		Change picture 
		<input type="file"/>
		</Button>*/}
                    </div>
                  </div>
                </div>

                <p className="text-gray-400 mt-2 font-light text-md">
                  Add your photo. The recommended size is 160x160px
                </p>
              </div>

              <div className="grid grid-cols-3 gap-x-9 px-4 py-4 border-t dark:bg-gray-800">
                <TextInput
                  defaultValue={user?.companyName ? user?.companyName : ""}
                  label="Company Name"
                  placeholder="Company Name"
                  register={{ ...register("CompanyName") }}
                  onChange={(e) =>
                    updateInputValue("CompanyName", e.target.value)
                  }
                />
                <TextInput
                  defaultValue={user?.lastName ? user?.lastName : ""}
                  label="Name"
                  placeholder="Last Name"
                  register={{ ...register("LastName") }}
                  onChange={(e) => updateInputValue("LastName", e.target.value)}
                />
                <TextInput
                  defaultValue={user?.firstName ? user?.firstName : ""}
                  label="FirstName"
                  register={{ ...register("FirstName") }}
                  onChange={(e) =>
                    updateInputValue("FirstName", e.target.value)
                  }
                />
              </div>

              <div className="grid grid-cols-3 gap-x-9 px-4 mb-4">
                <TextInput
                  defaultValue={
                    user?.companyWebsite ? user?.companyWebsite : ""
                  }
                  label="Website"
                  placeholder="http://www.xxxxx.com"
                  register={{ ...register("CompanyWebsite") }}
                  onChange={(e) =>
                    updateInputValue("CompanyWebsite", e.target.value)
                  }
                />
                <TextInput
                  defaultValue={user?.email ? user?.email : ""}
                  label="Email"
                  placeholder="Email"
                  register={{ ...register("Email") }}
                  onChange={(e) => updateInputValue("Email", e.target.value)}
                />
                <TextInput
                  defaultValue={user?.phoneNumber ? user?.phoneNumber : ""}
                  label="Phone number"
                  placeholder="+1 408 XXX XXXX"
                  register={{ ...register("PhoneNumber") }}
                  onChange={(e) =>
                    updateInputValue("PhoneNumber", e.target.value)
                  }
                />
              </div>

              <div className="checkbox-grid">
                <LabelInput
                  className="px-4 mb-3 font-semibold"
                  label="Company expertise"
                />
                <div className="checkItems grid grid-cols-2 px-4">
                  <CheckboxInput
                    id="ghg"
                    name="ghg"
                    label="GHG accounting and reporting"
                    value={1}
                    checked={companyExpertises?.includes(1)}
                    register={{ ...register("CompanyExpertise") }}
                    onChange={handleChangeCompanyExpertise}
                  />

                  <CheckboxInput
                    id="accessProvider"
                    name="accessProvider"
                    label="Carbon market access provider"
                    value={2}
                    checked={companyExpertises?.includes(2)}
                    register={{ ...register("CompanyExpertise") }}
                    onChange={handleChangeCompanyExpertise}
                  />

                  <CheckboxInput
                    id="assurance"
                    name="assurance"
                    label="Verification, assurance provider"
                    value={3}
                    checked={companyExpertises?.includes(3)}
                    register={{ ...register("CompanyExpertise") }}
                    onChange={handleChangeCompanyExpertise}
                  />

                  <CheckboxInput
                    id="other"
                    name="other"
                    label="Other"
                    value={4}
                    checked={companyExpertises?.includes(4)}
                    register={{ ...register("CompanyExpertise") }}
                    onChange={handleChangeCompanyExpertise}
                  />
                </div>
              </div>

              <div
                id="password-group"
                className="grid grid-cols-3 gap-x-9 px-4 mb-4"
              >
                <div className="mt-2">
                  {updatePassword === true ? (
                    <>
                      <div>
                        <PasswordInput
                          label="New Password"
                          name="newPassword"
                          placeholder="Enter new password"
                          register={{
                            ...register("Password", {
                              pattern: validPassword,
                            }),
                          }}
                          onChange={(e) =>
                            updateInputValue("Password", e.target.value)
                          }
                        />
                        {errors.Password &&
                          errors.Password.type === "pattern" && (
                            <Error
                              key={errorCount}
                              text={invalidPasswordMessage}
                            />
                          )}
                      </div>
                      <div className="my-3">
                        <PasswordInput
                          label="Confirm the password"
                          placeholder="Confirm the password"
                          name="confirmPassword"
                          register={{
                            ...register("ConfirmPassword", {
                              validate: (val) => val === passwordTyped,
                            }),
                          }}
                          onChange={(e) =>
                            updateInputValue("ConfirmPassword", e.target.value)
                          }
                        />
                        {errors.ConfirmPassword &&
                          errors.ConfirmPassword.type === "validate" && (
                            <Error
                              key={errorCount}
                              text={passwordsNotMatchMessage}
                            />
                          )}
                      </div>
                    </>
                  ) : (
                    <PasswordInput
                      label="Password"
                      value="m!44rerxzzLR;"
                      placeholder="Enter password"
                    />
                  )}
                  <a
                    className="text-coc-blue hover:text-coc-blue hover:underline flex items-center mt-3 text-xs"
                    href="#"
                    onClick={() => setUpdatePassword(true)}
                  >
                    Edit password{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="m3 w-3 h-3 ml-2 text-coc-blue"
                    >
                      <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
                    </svg>
                  </a>
                </div>

                <TextInput
                  defaultValue={user?.email}
                  label="Username"
                  placeholder="Username"
                  register={{ ...register("UserName") }}
                  onChange={(e) => updateInputValue("UserName", e.target.value)}
                />
              </div>

              <div className="flex justify-end items-center gap-x-2 py-3 px-4 bg-gray-50 border-t dark:bg-gray-800 dark:border-gray-700">
                <button
                  type="button"
                  className="py-2.5 px-4 inline-flex justify-center bg-gray-400 items-center gap-2 rounded-md border font-medium text-white shadow-sm align-middle hover:bg-gray-300 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-gray-800 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                  data-hs-overlay="#hs-user-details"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <SubmitButton
                  className="py-2.5 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-medium bg-coc-green text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-coc-green focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                  type="submit"
                  buttonText="Save changes"
                  onClick={() => setErrorCount(errorCount + 1)}
                  loading={isLoading}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
